    /* ==========================================================
   TDP SCENT FINDER QUIZ — Engine
   Ported from: lovable code/src/lib/scentQuizEngine.ts
   ========================================================== */
(function () {
  'use strict';

  /* ── Quiz Questions (identical to Lovable) ──────────────── */
  var QUESTIONS = [
    {
      id: 'gender',
      title: 'Who is this fragrance for?',
      subtitle: 'Select your preference',
      cols: 3,
      options: [
        { value: 'male',   label: 'Male',   emoji: '👔' },
        { value: 'female', label: 'Female', emoji: '👗' },
        { value: 'unisex', label: 'Unisex', emoji: '✨' }
      ]
    },
    {
      id: 'occasion',
      title: 'When will you wear this most?',
      subtitle: 'Pick your primary occasion',
      cols: 2,
      options: [
        { value: 'daily',   label: 'Daily / College / Office', emoji: '☀️', desc: 'Everyday confidence' },
        { value: 'date',    label: 'Date / Night Out',         emoji: '🌙', desc: 'Turn heads' },
        { value: 'party',   label: 'Parties / Events',         emoji: '🎉', desc: 'Be unforgettable' },
        { value: 'special', label: 'Special Occasions',        emoji: '💍', desc: 'Make it memorable' }
      ]
    },
    {
      id: 'vibe',
      title: 'What vibe do you want?',
      subtitle: 'Choose your signature energy',
      cols: 2,
      options: [
        { value: 'fresh',     label: 'Fresh & Clean',       emoji: '🧊', desc: 'Crisp, aquatic, invigorating' },
        { value: 'sweet',     label: 'Sweet & Attractive',  emoji: '🍬', desc: 'Warm, gourmand, magnetic' },
        { value: 'bold',      label: 'Bold & Powerful',     emoji: '💼', desc: 'Commanding, spicy, confident' },
        { value: 'dark',      label: 'Dark & Mysterious',   emoji: '🌙', desc: 'Smoky, intense, seductive' },
        { value: 'luxurious', label: 'Luxurious & Rich',    emoji: '💎', desc: 'Opulent, refined, elite' }
      ]
    },
    {
      id: 'budget',
      title: "What's your budget range?",
      subtitle: 'All prices include free delivery',
      cols: 3,
      options: [
        { value: '2000-5000',  label: '₹2,000 – ₹5,000', emoji: '💰', desc: 'Great value picks' },
        { value: '5000-10000', label: '₹5,000 – ₹10,000', emoji: '💎', desc: 'Premium selection' },
        { value: '10000+',     label: '₹10,000+',          emoji: '👑', desc: 'Ultra-luxury' }
      ]
    }
  ];

  var WHATSAPP_NUMBER = '918929799450';

  /* ── SVG Icons ──────────────────────────────────────────── */
  var ICONS = {
    sparkles: '<svg width="SIZE" height="SIZE" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="m12 3-1.912 5.813a2 2 0 0 1-1.275 1.275L3 12l5.813 1.912a2 2 0 0 1 1.275 1.275L12 21l1.912-5.813a2 2 0 0 1 1.275-1.275L21 12l-5.813-1.912a2 2 0 0 1-1.275-1.275L12 3Z"/></svg>',
    arrowLeft: '<svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="m12 19-7-7 7-7"/><path d="M19 12H5"/></svg>',
    arrowRight: '<svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M5 12h14"/><path d="m12 5 7 7-7 7"/></svg>',
    cart: '<svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><circle cx="8" cy="21" r="1"/><circle cx="19" cy="21" r="1"/><path d="M2.05 2.05h2l2.66 12.42a2 2 0 0 0 2 1.58h9.78a2 2 0 0 0 1.95-1.57l1.65-7.43H5.12"/></svg>',
    whatsapp: '<svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M3 21l1.65-3.8a9 9 0 1 1 3.4 2.9L3 21"/><path d="M9 10a.5.5 0 0 0 1 0V9a.5.5 0 0 0-1 0v1a5 5 0 0 0 5 5h1a.5.5 0 0 0 0-1h-1a.5.5 0 0 0 0 1"/></svg>',
    rotateCcw: '<svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M3 12a9 9 0 1 0 9-9 9.75 9.75 0 0 0-6.74 2.74L3 8"/><path d="M3 3v5h5"/></svg>',
    award: '<svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><circle cx="12" cy="8" r="6"/><path d="M15.477 12.89 17 22l-5-3-5 3 1.523-9.11"/></svg>',
    star: '<svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><polygon points="12 2 15.09 8.26 22 9.27 17 14.14 18.18 21.02 12 17.77 5.82 21.02 7 14.14 2 9.27 8.91 8.26 12 2"/></svg>',
    gift: '<svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><rect x="3" y="8" width="18" height="4" rx="1"/><path d="M12 8v13"/><path d="M19 12v7a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2v-7"/><path d="M7.5 8a2.5 2.5 0 0 1 0-5A4.8 8 0 0 1 12 8a4.8 8 0 0 1 4.5-5 2.5 2.5 0 0 1 0 5"/></svg>',
    msgCircle: '<svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M7.9 20A9 9 0 1 0 4 16.1L2 22Z"/></svg>',
    giftLg: '<svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><rect x="3" y="8" width="18" height="4" rx="1"/><path d="M12 8v13"/><path d="M19 12v7a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2v-7"/><path d="M7.5 8a2.5 2.5 0 0 1 0-5A4.8 8 0 0 1 12 8a4.8 8 0 0 1 4.5-5 2.5 2.5 0 0 1 0 5"/></svg>'
  };

  function icon(name, size) {
    return ICONS[name].replace(/SIZE/g, size || '24');
  }

  /* ── Helpers ────────────────────────────────────────────── */
  function formatPrice(amountCents) {
    var rupees = amountCents / 100;
    return '₹' + rupees.toLocaleString('en-IN', { maximumFractionDigits: 0 });
  }

  function parseTags(tags) {
    var result = { genders: [], occasions: [], vibes: [] };
    tags.forEach(function (tag) {
      var lower = tag.toLowerCase().trim();
      if (lower.indexOf('gender:') === 0) result.genders.push(lower.split(':')[1]);
      else if (lower.indexOf('occasion:') === 0) result.occasions.push(lower.split(':')[1]);
      else if (lower.indexOf('vibe:') === 0) result.vibes.push(lower.split(':')[1]);
    });
    return result;
  }

  function inBudget(price, budget) {
    var rupees = price / 100;
    switch (budget) {
      case '2000-5000':  return rupees >= 2000 && rupees <= 5000;
      case '5000-10000': return rupees > 5000 && rupees <= 10000;
      case '10000+':     return rupees > 10000;
      default:           return true;
    }
  }

  /* ── Scoring Engine (identical to Lovable) ──────────────── */
  function scoreScentQuiz(answers, products) {
    var scored = [];

    products.forEach(function (product) {
      var parsed = parseTags(product.tags);
      var price = product.price;

      // Hard gender filter
      if (answers.gender !== 'unisex') {
        if (parsed.genders.indexOf(answers.gender) === -1 && parsed.genders.indexOf('unisex') === -1) return;
      }

      // Budget filter
      if (!inBudget(price, answers.budget)) return;

      var score = 0;
      if (parsed.vibes.indexOf(answers.vibe) !== -1) score += 5;
      if (parsed.occasions.indexOf(answers.occasion) !== -1) score += 3;

      scored.push({ product: product, score: score, price: price });
    });

    // Sort by score desc, then price asc
    scored.sort(function (a, b) { return b.score - a.score || a.price - b.price; });

    var topPick = scored[0] ? scored[0].product : null;

    // Alternative: different vendor if possible
    var alt = null;
    for (var i = 1; i < scored.length; i++) {
      if (topPick && scored[i].product.vendor !== topPick.vendor) {
        alt = scored[i].product;
        break;
      }
    }
    if (!alt && scored[1]) alt = scored[1].product;

    // Budget option: cheapest that's not topPick or alt
    var cheapSorted = scored.slice().sort(function (a, b) { return a.price - b.price; });
    var budgetOption = null;
    for (var j = 0; j < cheapSorted.length; j++) {
      var p = cheapSorted[j].product;
      if ((!topPick || p.id !== topPick.id) && (!alt || p.id !== alt.id)) {
        budgetOption = p;
        break;
      }
    }

    return { topPick: topPick, alternative: alt, budgetOption: budgetOption };
  }

  /* ── DOM Renderer ───────────────────────────────────────── */
  function TDPScentQuiz(rootEl) {
    var products = [];
    var answers = {};
    var currentStep = 'intro'; // intro | q0..q3 | loading | results
    var direction = 1;

    // Parse products from embedded JSON
    var jsonEl = rootEl.querySelector('#tdp-quiz-products');
    if (jsonEl) {
      try { products = JSON.parse(jsonEl.textContent); } catch (e) { console.error('Quiz: product JSON parse error', e); }
    }

    var container = rootEl.querySelector('.tdp-quiz__inner');

    function render() {
      var html = '';

      // Progress bar (visible during questions only)
      var qIdx = getQuestionIndex();
      if (qIdx >= 0) {
        var pct = ((qIdx + 1) / 4) * 100;
        html += '<div class="tdp-quiz__progress-wrap">';
        html += '  <div class="tdp-quiz__progress-header">';
        html += '    <button class="tdp-quiz__back-btn" data-action="back">' + ICONS.arrowLeft + ' Back</button>';
        html += '    <span class="tdp-quiz__step-label">Step ' + (qIdx + 1) + ' of 4</span>';
        html += '  </div>';
        html += '  <div class="tdp-quiz__progress-track"><div class="tdp-quiz__progress-fill" style="width:' + pct + '%"></div></div>';
        html += '</div>';
      }

      // Steps
      if (currentStep === 'intro') {
        html += renderIntro();
      } else if (qIdx >= 0) {
        html += renderQuestion(QUESTIONS[qIdx]);
      } else if (currentStep === 'loading') {
        html += renderLoading();
      } else if (currentStep === 'results') {
        html += renderResults();
      }

      container.innerHTML = html;
      bindEvents();
    }

    function getQuestionIndex() {
      if (currentStep.charAt(0) === 'q') return parseInt(currentStep.charAt(1), 10);
      return -1;
    }

    function renderIntro() {
      var s = '';
      s += '<div class="tdp-quiz__step active tdp-quiz__intro">';
      s += '  <div class="tdp-quiz__intro-icon">' + icon('sparkles', '32') + '</div>';
      s += '  <h1>Find Your Signature Scent</h1>';
      s += '  <span class="tdp-gold-line-wide"></span>';
      s += '  <p class="tdp-quiz__intro-desc">Answer 4 quick questions and we\'ll match you with your perfect fragrance from our curated collection.</p>';
      s += '  <p class="tdp-quiz__intro-meta">Takes less than 60 seconds · Personalized recommendations</p>';

      if (products.length === 0) {
        s += '  <div class="tdp-quiz__intro-loading"><div class="tdp-quiz__spinner" style="width:20px;height:20px;border-width:2px;"></div><span>Loading fragrances…</span></div>';
      } else {
        s += '  <button class="tdp-btn-primary" data-action="start">' + icon('sparkles', '16') + ' Start the Quiz ' + ICONS.arrowRight + '</button>';
      }

      s += '</div>';
      return s;
    }

    function renderQuestion(q) {
      var colClass = q.options.length <= 3 ? 'tdp-quiz__options--cols-3' : 'tdp-quiz__options--cols-2';
      var animClass = direction > 0 ? 'active' : 'active';
      var s = '';
      s += '<div class="tdp-quiz__step ' + animClass + ' tdp-quiz__question"' + (direction < 0 ? ' style="animation-name:tdp-quiz-slide-in-reverse"' : '') + '>';
      s += '  <div class="tdp-quiz__question-header">';
      s += '    <h2>' + q.title + '</h2>';
      s += '    <p>' + q.subtitle + '</p>';
      s += '  </div>';
      s += '  <div class="tdp-quiz__options ' + colClass + '">';
      q.options.forEach(function (opt) {
        var sel = answers[q.id] === opt.value ? ' selected' : '';
        s += '<button class="tdp-quiz__option' + sel + '" data-action="answer" data-qid="' + q.id + '" data-value="' + opt.value + '">';
        s += '  <span class="tdp-quiz__option-emoji">' + opt.emoji + '</span>';
        s += '  <span class="tdp-quiz__option-label">' + opt.label + '</span>';
        if (opt.desc) s += '  <span class="tdp-quiz__option-desc">' + opt.desc + '</span>';
        s += '</button>';
      });
      s += '  </div>';
      s += '</div>';
      return s;
    }

    function renderLoading() {
      var s = '';
      s += '<div class="tdp-quiz__step active tdp-quiz__loading">';
      s += '  <div class="tdp-quiz__spinner"></div>';
      s += '  <h2>Finding Your Perfect Match…</h2>';
      s += '  <p>Analyzing our collection against your preferences</p>';
      s += '</div>';
      return s;
    }

    function renderResults() {
      var results = scoreScentQuiz(answers, products);
      var hasResults = results.topPick || results.alternative || results.budgetOption;
      var s = '';

      s += '<div class="tdp-quiz__step active tdp-quiz__results">';

      // Header
      s += '<div class="tdp-quiz__results-header">';
      s += '  <div class="tdp-quiz__results-icon">' + icon('sparkles', '24') + '</div>';
      s += '  <h2>Your Perfect Matches</h2>';
      s += '  <p>Based on your preferences, here are our top recommendations</p>';
      s += '</div>';

      if (hasResults) {
        s += '<div class="tdp-quiz__results-grid">';
        if (results.topPick) s += renderProductCard(results.topPick, 'Top Pick', 'award', true);
        if (results.alternative) s += renderProductCard(results.alternative, 'Also Great', 'star', false);
        if (results.budgetOption) s += renderProductCard(results.budgetOption, 'Great Value', 'gift', false);
        s += '</div>';

        // Gift strip
        s += '<div class="tdp-quiz__gift-strip">';
        s += '  ' + ICONS.giftLg;
        s += '  <p>Every order includes a <span class="gold">complimentary surprise gift</span> 🎁</p>';
        s += '</div>';
      } else {
        s += '<div class="tdp-quiz__no-results">';
        s += '  <p>We couldn\'t find an exact match in our current collection for your preferences.</p>';
        s += '</div>';
      }

      // Footer CTAs
      s += '<div class="tdp-quiz__results-footer">';
      s += '  <button class="tdp-quiz__retake-btn" data-action="retake">' + ICONS.rotateCcw + ' Retake Quiz</button>';
      s += '  <div class="tdp-quiz__help-box">';
      s += '    <p>Didn\'t find your perfect match?</p>';
      s += '    <a href="https://wa.me/' + WHATSAPP_NUMBER + '?text=' + encodeURIComponent("Hi! I took the Scent-Finder quiz but couldn't find my perfect match. Can you help me source a specific fragrance?") + '" target="_blank" rel="noopener noreferrer">';
      s += '      ' + ICONS.msgCircle + ' We\'ll source it for you → Personal Sourcing Service';
      s += '    </a>';
      s += '  </div>';
      s += '</div>';

      s += '</div>';
      return s;
    }

    function renderProductCard(product, badge, badgeIcon, isHero) {
      var heroClass = isHero ? ' tdp-quiz__result-card--hero' : '';
      var waMsg = encodeURIComponent('Hi! The Scent-Finder quiz recommended "' + product.title + '" for me. I\'d like to order it.');
      var s = '';

      s += '<div class="tdp-quiz__result-card' + heroClass + '">';
      s += '  <div class="tdp-quiz__result-badge">' + ICONS[badgeIcon] + ' ' + badge + '</div>';

      s += '  <div style="display:flex;flex-direction:column;"' + (isHero ? ' class="tdp-quiz__result-card-inner"' : '') + '>';

      // Image
      s += '  <div class="tdp-quiz__result-image">';
      s += '    <img src="' + (product.image || '') + '" alt="' + product.title + '" loading="lazy">';
      s += '  </div>';

      // Info
      s += '  <div class="tdp-quiz__result-info">';
      s += '    <p class="tdp-quiz__result-vendor">' + product.vendor + '</p>';
      s += '    <h3 class="tdp-quiz__result-title">' + product.title + '</h3>';
      s += '    <p class="tdp-quiz__result-price">' + formatPrice(product.price) + '</p>';
      if (product.description) {
        s += '  <p class="tdp-quiz__result-desc">' + product.description + '</p>';
      }

      // Buttons
      s += '    <div class="tdp-quiz__result-actions">';
      s += '      <button class="tdp-quiz__result-btn-cart" data-action="add-cart" data-variant-id="' + product.variant_id + '">' + ICONS.cart + ' Add to Cart</button>';
      s += '      <a href="' + product.url + '" class="tdp-quiz__result-btn-wa">' + ICONS.cart + ' Buy Now</a>';
      s += '    </div>';
      s += '    <a href="' + product.url + '" class="tdp-quiz__result-link">View Full Details →</a>';
      s += '  </div>';

      s += '  </div>';
      s += '</div>';
      return s;
    }

    /* ── Event Binding ────────────────────────────────────── */
    function bindEvents() {
      container.querySelectorAll('[data-action]').forEach(function (el) {
        el.addEventListener('click', handleAction);
      });
    }

    function handleAction(e) {
      var btn = e.currentTarget;
      var action = btn.getAttribute('data-action');

      if (action === 'start') {
        direction = 1;
        currentStep = 'q0';
        render();
      } else if (action === 'answer') {
        var qid = btn.getAttribute('data-qid');
        var value = btn.getAttribute('data-value');
        answers[qid] = value;
        direction = 1;

        var qIdx = getQuestionIndex();
        if (qIdx < 3) {
          currentStep = 'q' + (qIdx + 1);
          render();
        } else {
          currentStep = 'loading';
          render();
          setTimeout(function () {
            currentStep = 'results';
            render();
            // Scroll to top of quiz
            rootEl.scrollIntoView({ behavior: 'smooth', block: 'start' });
          }, 1500);
        }
      } else if (action === 'back') {
        direction = -1;
        var qi = getQuestionIndex();
        if (qi > 0) {
          currentStep = 'q' + (qi - 1);
        } else if (qi === 0) {
          currentStep = 'intro';
        }
        render();
      } else if (action === 'retake') {
        answers = {};
        direction = -1;
        currentStep = 'intro';
        render();
        rootEl.scrollIntoView({ behavior: 'smooth', block: 'start' });
      } else if (action === 'add-cart') {
        var variantId = btn.getAttribute('data-variant-id');
        addToCart(variantId, btn);
      }
    }

    /* ── Shopify AJAX Cart ────────────────────────────────── */
    function addToCart(variantId, btnEl) {
      btnEl.disabled = true;
      btnEl.innerHTML = '<div class="tdp-quiz__spinner" style="width:16px;height:16px;border-width:2px;display:inline-block;vertical-align:middle;margin-right:6px;"></div> Adding…';

      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: variantId, quantity: 1 })
      })
        .then(function (res) { return res.json(); })
        .then(function () {
          btnEl.innerHTML = '✓ Added!';
          btnEl.style.background = '#2d6a4f';
          setTimeout(function () {
            btnEl.disabled = false;
            btnEl.innerHTML = ICONS.cart + ' Add to Cart';
            btnEl.style.background = '';
          }, 2000);
          // Update cart count in header if Dawn's cart bubble exists
          fetch('/cart.js').then(function (r) { return r.json(); }).then(function (cart) {
            var bubble = document.querySelector('.cart-count-bubble span[aria-hidden]');
            if (bubble) bubble.textContent = cart.item_count;
            var srBubble = document.querySelector('.cart-count-bubble .visually-hidden');
            if (srBubble) srBubble.textContent = cart.item_count + ' items';
          });
        })
        .catch(function () {
          btnEl.innerHTML = 'Error – try again';
          btnEl.disabled = false;
          setTimeout(function () { btnEl.innerHTML = ICONS.cart + ' Add to Cart'; }, 2000);
        });
    }

    // Hero card inner flex on desktop
    function addHeroStyles() {
      var style = document.createElement('style');
      style.textContent = '@media(min-width:750px){.tdp-quiz__result-card--hero > div:first-of-type, .tdp-quiz__result-card-inner{flex-direction:row !important;display:flex !important;}.tdp-quiz__result-card--hero .tdp-quiz__result-image{width:50%;flex-shrink:0;}}';
      document.head.appendChild(style);
    }

    // Init
    addHeroStyles();
    render();
  }

  /* ── Boot ────────────────────────────────────────────────── */
  document.addEventListener('DOMContentLoaded', function () {
    var root = document.getElementById('tdp-scent-finder-quiz');
    if (root) new TDPScentQuiz(root);
  });

})();

    


    
